// @ts-nocheck
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import TagHero from 'flarum/tags/forum/components/TagHero';

app.initializers.add('gcs-tag-images-forum', () => {
  // Wrap title en subtitle in een container voor betere layout
  extend(TagHero.prototype, 'view', function (vnode) {
    const tag = this.attrs.model;
    if (!tag) return;

    const imageUrl = tag.attribute('imageUrl');
    if (!imageUrl) return;

    // Zoek de containerNarrow div en restructureer de inhoud
    const findAndRestructure = (vnodes) => {
      if (!vnodes) return;

      if (Array.isArray(vnodes)) {
        vnodes.forEach(findAndRestructure);
      } else if (vnodes.children) {
        // Check if this is the containerNarrow div
        if (vnodes.attrs && vnodes.attrs.className === 'containerNarrow') {
          const children = Array.isArray(vnodes.children) ? vnodes.children : [vnodes.children];

          // Vind de image, title en subtitle
          const imageIndex = children.findIndex(c => c?.attrs?.className === 'TagHero-image');
          const titleIndex = children.findIndex(c => c?.attrs?.className === 'Hero-title');
          const subtitleIndex = children.findIndex(c => c?.attrs?.className === 'Hero-subtitle');

          if (imageIndex !== -1 && titleIndex !== -1) {
            const image = children[imageIndex];
            const title = children[titleIndex];
            const subtitle = subtitleIndex !== -1 ? children[subtitleIndex] : null;

            // Maak een nieuwe structuur: image + wrapper met title en subtitle
            const textWrapper = m('div.TagHero-text', [title, subtitle].filter(Boolean));

            // Vervang de children
            vnodes.children = [image, textWrapper];
          }
        } else {
          findAndRestructure(vnodes.children);
        }
      }
    };

    findAndRestructure(vnode);
  });

  // Voeg het tag-plaatje toe in de TagHero boven de titel
  extend(TagHero.prototype, 'contentItems', function (items) {
    const tag = this.attrs.model;
    if (!tag) return;

    const imageUrl = tag.attribute('imageUrl');
    if (!imageUrl) return;

    items.add(
      'tag-image',
      m('div.TagHero-image', [
        m('img', {
          src: imageUrl,
          alt: tag.name(),
        }),
      ]),
      110 // boven tag-title (100) en tag-subtitle (90)
    );
  });
});
